import { render, staticRenderFns } from "./SnacksQueue.vue?vue&type=template&id=397996fe"
import script from "./SnacksQueue.vue?vue&type=script&lang=js"
export * from "./SnacksQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports